import { useGetBranding } from '@sanlam-glacier/app-common/modules/theme';
import { useConfig } from 'providers/config/ConfigProvider';
import styles from './top-app-bar.module.scss';
import { SideNavigationBar } from '../../molecules/side-navigation-bar/SideNavigationBar';
import { TopNavigationBar } from '../../molecules/top-navigation-bar/TopNavigationBar';
import { ContextMenu } from '../../molecules/context-menu/ContextMenu';

const NavigationBarBranding = () => {
  const { theme } = useConfig();
  const { brandLogo, glacierLogo } = useGetBranding(theme);
  return (
    <div className={styles.logoContainer}>
      <img alt='Sanlam Glacier' className={styles.topBarIcon} src={glacierLogo} />
      {brandLogo && (
        <>
          <div className={styles.logoDivider} />
          <img alt='AF' className={styles.brandLogo} src={brandLogo} />
        </>
      )}
    </div>
  );
};

export const TopAppBar = () => {
  return (
    <div className={styles.appBar}>
      <SideNavigationBar className={styles.mobileMenuContent} />
      <div className={styles.appBarInner}>
        <NavigationBarBranding />
        <TopNavigationBar className={styles.desktopMenuContent} />
      </div>
      <div style={{ display: 'flex', gap: '32px', height: '100%', alignItems: 'center' }}>
        <div className={styles.userInfoSection}>
          <ContextMenu />
        </div>
      </div>
    </div>
  );
};
